import isNil from 'lodash/isNil';
import omitBy from 'lodash/omitBy';

import { QueryResources } from '@/lib/datx-jsonapi-react';
import { EventSponsorPackage } from '@/resources/EventSponsorPackage';

interface IQueryEventSponsorPackagesProps {
  filters?: Record<string, string>;
  sort?: string;
}

export const queryEventSponsorPackagesWithEventSponsors = ({
  filters,
  sort = 'position',
}: IQueryEventSponsorPackagesProps): QueryResources<EventSponsorPackage> => {
  return [
    EventSponsorPackage,
    {
      filter: {
        ...omitBy(filters, isNil),
      },
      include: ['event_sponsors'],
      sort: sort,
      loadAll: true,
    },
  ];
};
